import { render, staticRenderFns } from "./AggregatorIcons.vue?vue&type=template&id=fb6a55a6&scoped=true&"
import script from "./AggregatorIcons.vue?vue&type=script&lang=js&"
export * from "./AggregatorIcons.vue?vue&type=script&lang=js&"
import style0 from "./AggregatorIcons.vue?vue&type=style&index=0&id=fb6a55a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a55a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6a55a6')) {
      api.createRecord('fb6a55a6', component.options)
    } else {
      api.reload('fb6a55a6', component.options)
    }
    module.hot.accept("./AggregatorIcons.vue?vue&type=template&id=fb6a55a6&scoped=true&", function () {
      api.rerender('fb6a55a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/stop/helpers/AggregatorIcons.vue"
export default component.exports